<template>
  <div :class="$style.leadBlock"><slot></slot></div>
</template>

<script>
export default {
  name: "vc-share-info-lead-block"
};
</script>

<style module>
.leadBlock {
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #ccc;
  margin: 10px 0 16px;
}
</style>
